import React, { useEffect, useState } from 'react';
import '../styles/GodMode.css';
import { checkOnAuthStateChanged, cloudFunctionV2 } from '../functions';
import { useNavigate } from 'react-router-dom';
import { Header, Footer, OptionSwitch, SearchesTable, CompaniesTable, Modal, UsersPanel, Input, Loading } from '../components';
import moment from 'moment';
import { CreateCompany } from '../modalbody';

function GodMode() {
    const [loggedIn, setLoggedIn] = useState(null);
    const [searches, setSearches] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [searchesActive, setSearchesActive] = useState(true);
    const [newCompanyModal, setNewCompanyModal] = useState(false);
    const [newCompanyName, setNewCompanyName] = useState("");
    const [adminUserId, setAdminUserId] = useState("");
    const [modalLoading, setModalLoading] = useState(false);
    const [showUsersPanel, setShowUsersPanel] = useState(false);
    const [companyUsersId, setCompanyUsersId] = useState(null);
    const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);
    const [deleteUserObject, setDeleteUserObject] = useState(null);
    const [newUserModal, setNewUserModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [addUserUserId, setAddUserUserId] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "God Mode | Clozers";

        const fetchCompanies = async() => {
            const url = process.env.REACT_APP_GET_ALL_DOCS;
            const colRef = "companies";
            const params = {
                collection: colRef,
                subcollection: null
            }
            const queryData = await cloudFunctionV2(url, params);
            if ( queryData.status === 200 ) {
                setCompanies(queryData.data);
            }
        };

        const fetchRecentSearches = async() => {
            const url = process.env.REACT_APP_GET_ORDERED_DOCS;
            const params = {
                collection: "recent_searches",
                subcollection: null,
                document: null,
                field: "data.date",
                order: "desc",
                limit: 50
            };
            const queryData = await cloudFunctionV2(url, params);
            if ( queryData.status === 200 ) {
                const recentData = queryData.data;
                for (let index = 0; index < recentData.length; index++) {
                    const element = recentData[index];
                    const companyId = element.data.companyId;
                    const propertyId = `${element.data.propertyId}`;

                    const queryURL = process.env.REACT_APP_GET_DOCUMENT;    
                    const queryParams = {
                        collection: "companies",
                        document: companyId,
                        subcollection: "properties",
                        subdocument: propertyId
                    };
                    const queryPropertyData = await cloudFunctionV2(queryURL, queryParams);
                    if ( queryPropertyData.status === 200 ) {
                        const propertyData = queryPropertyData.data.data;
                        const totalCost = propertyData.totalCost;
                        if ( totalCost !== undefined ) {
                            recentData[index].data.totalCost = Number(totalCost);
                        }
                    }
                }
                setSearches(recentData);
            }
        };

        const fetchUserData = async() => {
            const user = await checkOnAuthStateChanged();
            if ( user.status === 200 ) {
                const admins = JSON.parse(process.env.REACT_APP_ADMINIDS);
                const isAdmin = admins.includes(user.userId);
                if ( isAdmin === false ) {
                    navigate("/");
                }
                else {
                    setLoggedIn(true);
                    fetchRecentSearches();
                    fetchCompanies();
                }
            }
            else {
                navigate("/login");
            }

            setLoading(false);
        };

        fetchUserData();
    }, [navigate]);

    const toggleSwitch = (val) => {
        setSearchesActive(val);
    };

    const openNewCompanyModal = () => {
        setNewCompanyModal(true);
    };

    const closeNewCompanyModal = () => {
        setNewCompanyModal(false);
    };

    const onChangeNewCompanyName = (e) => {
        setNewCompanyName(e.target.value);
    };

    const onChangeAdminUserId = (e) => {
        setAdminUserId(e.target.value);
    };

    const closeUsersPanel = () => {
        setShowUsersPanel(false);
        setCompanyUsersId(null);
    };

    const closeNewUserModal = () => {
        setNewUserModal(false);
        setAddUserUserId("");
    };

    const onChangeAddAddUserId = (e) => {
        setAddUserUserId(e.target.value);
    };

    const addUserToCompany = async() => {
        setModalLoading(true);
        const url = process.env.REACT_APP_ADD_REMOVE_USER;
        const params = {
            companyId: companyUsersId,
            userId: addUserUserId,
            admin: false,
            remove: false
        };

        const queryAddition = await cloudFunctionV2(url, params);
        if ( queryAddition.status === 200 ) {
            const newUser = queryAddition.data;
            const isoString = newUser.date;
            const date = new Date(isoString);
            const timestampObject = { _seconds: Math.floor(date.getTime() / 1000) };
            newUser.date = timestampObject;
            const newCompanies = [...companies];
            const companyIndex = newCompanies.findIndex(e => e.id === companyUsersId);
            newCompanies[companyIndex].data.users.push(newUser);
            setCompanies(newCompanies);
            closeNewUserModal();
        }
        else {
            alert(`Error: ${queryAddition.error}`);
        }
        setModalLoading(false);
    };

    const closeDeleteUserModal = () => {
        setShowDeleteUserModal(false);
    };

    const deleteUserFromCompany = async() => {
        setModalLoading(true);
        const url = process.env.REACT_APP_ADD_REMOVE_USER;
        const params = {
            companyId: companyUsersId,
            userId: deleteUserObject.userId,
            admin: false,
            remove: true
        };

        const queryDeletion = await cloudFunctionV2(url, params);
        if ( queryDeletion.status === 200 ) {
            const newCompanies = [...companies];
            const companyIndex = newCompanies.findIndex(e => e.id === companyUsersId);
            const userIndex = newCompanies[companyIndex].data.users.findIndex(e => e.userId === deleteUserObject.userId);
            newCompanies[companyIndex].data.users.splice(userIndex, 1);
            setCompanies(newCompanies);
            closeDeleteUserModal();
        }
        else {
            alert(`Error: ${queryDeletion.error}`);
        }
        setModalLoading(false);
    };

    const createCompany = async() => {
        setModalLoading(true);
        const url = process.env.REACT_APP_GET_DOCUMENT;
        const params = {
            collection: "users",
            document: adminUserId,
            subcollection: null,
            subdocument: null
        };
        const queryData = await cloudFunctionV2(url, params);
        if ( queryData.status === 200 ) {
            const userData = queryData.data.data;

            const startDate = new Date();
            const endDate = moment(startDate).add(1, 'month').toDate();
            const newObject = {
                autoBilling: true,
                companyId: "",
                companyName: newCompanyName,
                credits: 2,
                endDate: endDate,
                id: "",
                logo: null,
                monthly: true,
                price: 0,
                startDate: startDate,
                subscriptions: [],
                users: [
                    {
                        admin: true,
                        email: userData.email,
                        userId: adminUserId,
                        firstName: userData.firstName,
                        lastName: userData.lastName,
                        date: new Date()
                    }
                ]
            };

            const createCompanyURL = process.env.REACT_APP_CREATE_COMPANY;
            const createCompanyParams = {
                data: newObject,
                userId: adminUserId
            };
            await cloudFunctionV2(createCompanyURL, createCompanyParams);
            closeNewCompanyModal();
        }
        setModalLoading(false);
    };

    return (
        <div className={"god-mode-outer-container " + (newCompanyModal === true || showUsersPanel === true ? "relative-container" : "")}>
            <Header
                loggedIn={loggedIn}
            />
            {
                loading === true &&
                <Loading />
            }
            {
                (newCompanyModal === true || showUsersPanel === true) &&
                <div className="dark-bg">
                </div>
            }
            {
                loggedIn === false ?
                <div className="god-mode-inner-container">
                </div>
                :
                <div className="god-mode-inner-container">
                    {
                        newCompanyModal === true &&
                        <Modal
                            heading="New company"
                            subheading={null}
                            body={<CreateCompany companyName={newCompanyName} onChangeCompanyName={onChangeNewCompanyName} adminUserId={adminUserId} onChangeAdminUserId={onChangeAdminUserId} />}
                            type="basic"
                            cancelText="Cancel"
                            cancelButtonCTA={() => closeNewCompanyModal()}
                            actionButtonText="Submit"
                            actionButtonCTA={() => createCompany()}
                            secondaryButtonText={null}
                            secondaryButtonCTA={null}
                            exitButtonCTA={closeNewCompanyModal}
                            loading={modalLoading}
                            actionButtonDisabled={newCompanyName === "" || adminUserId === "" || modalLoading === true ? true : false}
                            leftIcon={null}
                            rightIcon={null}
                            cancelLeftIcon={null}
                            cancelRightIcon={null}
                            customClass=""
                        />
                    }
                    {
                        showDeleteUserModal === true &&
                        <Modal
                            heading="Are you sure"
                            subheading={null}
                            body={<div className="show-delete-user-modal-container"><span className="body-regular colour-primary">Are you sure you want to delete this user?</span><span className="body-bold colour-primary">{deleteUserObject.firstName} {deleteUserObject.lastName}</span></div>}
                            type="basic"
                            cancelText="Cancel"
                            cancelButtonCTA={() => closeDeleteUserModal()}
                            actionButtonText="Yes, delete user"
                            actionButtonCTA={() => deleteUserFromCompany()}
                            secondaryButtonText={null}
                            secondaryButtonCTA={null}
                            exitButtonCTA={closeDeleteUserModal}
                            loading={modalLoading}
                            actionButtonDisabled={modalLoading}
                            leftIcon={null}
                            rightIcon={null}
                            cancelLeftIcon={null}
                            cancelRightIcon={null}
                            customClass=""
                        />
                    }
                    {
                        newUserModal === true &&
                        <Modal
                            heading="Add new user"
                            subheading={null}
                            body={<div className="show-add-user-modal-container"><Input label={"User ID"} labelType={"default"} secondaryLabelGrey={null} info={false} value={addUserUserId} onChange={onChangeAddAddUserId} placeholder={"ABC123"} type="text" leftUnit={null} rightUnit={null} unitSwitch={false} leftUnitSelected={true} unitSwitchFunc={null} disabled={false} multiline={false} error={false} onMouseEnter={null} onMouseLeave={null} reset={false} resetFunc={null} resetPosition={null} focusMultiline={false} prompt={false} /></div>}
                            type="basic"
                            cancelText="Cancel"
                            cancelButtonCTA={() => closeNewUserModal()}
                            actionButtonText="Add user"
                            actionButtonCTA={() => addUserToCompany()}
                            secondaryButtonText={null}
                            secondaryButtonCTA={null}
                            exitButtonCTA={closeNewUserModal}
                            loading={modalLoading}
                            actionButtonDisabled={modalLoading}
                            leftIcon={null}
                            rightIcon={null}
                            cancelLeftIcon={null}
                            cancelRightIcon={null}
                            customClass=""
                        />
                    }
                    {
                        showUsersPanel === true && companyUsersId !== null &&
                        <UsersPanel
                            company={companies[companies.findIndex(e => e.id === companyUsersId)].data}
                            closeUsersPanel={closeUsersPanel}
                            setShowDeleteUserModal={setShowDeleteUserModal}
                            setDeleteUserObject={setDeleteUserObject}
                            setNewUserModal={setNewUserModal}
                            backDisabled={showDeleteUserModal === true || newUserModal === true ? true : false}
                        />
                    }
                    <div className="god-mode-switch-container">
                        <OptionSwitch
                            labels={["Searches", "Customers"]}
                            firstOption={searchesActive}
                            disabled={false}
                            optionSwitch={() => toggleSwitch(!searchesActive)}
                            switchWidth={170}
                            leftWidth={0.48}
                            rightWidth={0.48}
                        />
                    </div>
                    <div className="god-mode-body-container">
                        {
                            searchesActive === true ?
                            <SearchesTable
                                data={searches}
                                companies={companies}
                                navigate={navigate}
                            />
                            :
                            <CompaniesTable
                                data={companies}
                                navigate={navigate}
                                openNewCompanyModal={openNewCompanyModal}
                                setShowUsersPanel={setShowUsersPanel}
                                setCompanyUsersId={setCompanyUsersId}
                            />
                        }
                    </div>
                </div>
            }
            <Footer />
        </div>
    )
};

export default GodMode;